import React, { useState } from "react";
import PropTypes from "prop-types";
import { Droppable, Draggable } from "react-beautiful-dnd";

import AgendaItemDropdown from "../AgendaItemDropdown";
// import AddNewModal from "ManagementTeam/Shared/AddNewModal";
// import { useAuth } from "shared/@auth";

import styles from "./AgendaDragDropContainer.module.css";

/**Component that consists of a drag & drop area and takes in drag & droppable agenda items */
export function AgendaDragDropContainer({
  dropdownData,
  onClickPdf,
  onDelete,
  onMove,
  onEdit,
  onActionItem,
  onComplete,
  onPublish,
  readOnly = false,
  isArchived,
  isActionItem = false,
  attendanceItem = null,
  isHideInfo,
}) {
  return (
    <>
      <div className={styles.headerContainer}>
        <div className={styles.tableHeader}>
          <span>Topic</span>
          <span>Voting Results</span>
          <span>Documents</span>
          <span>Complete</span>
        </div>
        <span className={styles.spacer}></span>
      </div>
      {dropdownData && dropdownData.length < 1 ? (
        <></>
      ) : (
        <Droppable droppableId="agendaItems">
          {(provided) => (
            <div
              className={styles.dropArea}
              {...provided.droppableProps}
              ref={provided.innerRef}
            >
              {dropdownData &&
                dropdownData.length &&
                dropdownData
                  .filter((drop) => {
                    if (isHideInfo) {
                      if (drop.isDraft && !isActionItem) {
                        return false;
                      }
                    }
                    return true;
                  })
                  .map((drop, index) => {
                    return (
                      <Draggable
                        key={drop._id}
                        draggableId={drop._id}
                        index={index}
                        isDragDisabled={
                          dropdownData.length === 1 ||
                          isArchived ||
                          isActionItem
                        }
                      >
                        {(provided) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            style={{
                              marginTop: "16px",
                              position: "relative",
                              height: "fit-content",
                              ...provided.draggableProps.style,
                            }}
                          >
                            <div
                              {...(provided.dragHandleProps && {
                                ...provided.dragHandleProps,
                              })}
                              style={{
                                position: "absolute",
                                left: "0",
                                width: "2.9%",
                                height: "100%",
                                display: "flex",
                                ...(provided.dragHandleProps && {
                                  ...provided.dragHandleProps.style,
                                }),
                              }}
                            ></div>
                            <AgendaItemDropdown
                              readOnly={readOnly}
                              id={drop.id}
                              filesAttendance={drop.filesAttendance}
                              assignee={drop.owner.name}
                              assignedType={
                                drop.owner.name
                                  .toUpperCase()
                                  .includes("PAUL TSIKA") ||
                                drop.owner.name.includes("Attorneys")
                                  ? "Attorney"
                                  : drop.owner.name.includes("WWG") ||
                                    drop.owner.name.includes("WWG Guest")
                                  ? "WWG"
                                  : "Diamond"
                              }
                              title={drop.title}
                              description={drop.description}
                              isNew={drop.isNew}
                              isCompleted={
                                drop.isComplete === true ? true : false
                              }
                              isDraft={drop.isDraft}
                              votingStatus={
                                drop.decision?.status === "on"
                                  ? "Voting in Progress"
                                  : drop.decision?.status === "off"
                                  ? "Upcoming"
                                  : drop.decision?.votingStatus
                              }
                              pdfName={
                                drop.document &&
                                drop.document.files &&
                                drop.document.files.length > 0
                                  ? `${drop.document.files[0].name}.${drop.document.files[0].type}`
                                  : ""
                              }
                              canDownload={
                                drop.document &&
                                drop.document.files &&
                                drop.document.files.length > 0
                              }
                              onClickPdf={() => {
                                onClickPdf(
                                  drop.document &&
                                    drop.document.files &&
                                    drop.document.files.length > 0
                                    ? drop.document.files
                                    : null
                                );
                              }}
                              onClickAttendancePdf={() => {
                                onClickPdf(
                                  drop.filesAttendance &&
                                    drop.filesAttendance &&
                                    drop.filesAttendance.length > 0
                                    ? drop.filesAttendance
                                    : null
                                );
                              }}
                              hasNotes={
                                drop?.notes?.find(
                                  (note) =>
                                    note.location &&
                                    note.location.toUpperCase() === "AGENDAS"
                                ) != null
                              }
                              onEdit={() => onEdit(drop)}
                              onDelete={() => onDelete(drop)}
                              onMove={() => onMove(drop)}
                              onActionItem={() => onActionItem(drop)}
                              onComplete={() => onComplete(drop)}
                              onPublish={() => onPublish(drop)}
                              isActionItem={isActionItem}
                              isAttendanceAgenda={drop?.isAttendanceAgenda}
                              attendanceItem={attendanceItem}
                              actionItem={drop.hasActionItem}
                            />
                          </div>
                        )}
                      </Draggable>
                    );
                  })}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      )}
    </>
  );
}

AgendaDragDropContainer.propTypes = {
  /** Array of objects that contain the data for each of the Agenda Item Dropdown children components. <br />
   * {<br />
   *  title: string<br />
   *  description: string<br />
   *  assignee: string<br />
   *  assignedType: string<br />
   *  isNew: bool<br />
   *  isCompleted: bool<br />
   *  votingStatus: string<br />
   *  onEdit: function<br />
   *  onDelete: function<br />
   *  onMove: function<br />
   *  onActionItem: function<br />
   * }
   */
  dropdownData: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
      assignee: PropTypes.string,
      assignedType: PropTypes.string,
      isNew: PropTypes.bool,
      isCompleted: PropTypes.bool,
      votingStatus: PropTypes.string,
    })
  ),
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  onMove: PropTypes.func,
  onActionItem: PropTypes.func,
  onPublish: PropTypes.func,
};
